import FunnelPage from "./FunnelPage";

export default function FunnelKcisClinical() {
  return (
    <FunnelPage
      funnelKey="kcis_clinical_assessment"
      eyebrow="KCIS Clinical Assessment™"
      headline="Your full clinical intelligence report."
      body="The KCIS Clinical Assessment™ is our deepest intake — a multi-layer questionnaire paired with AI-generated root-cause insights and a personalized 12-week protocol delivered to your inbox."
      comingNext="Paid intake opens shortly — reserve your spot"
      noteLabel="Preferred contact time? (optional)"
      notePlaceholder="e.g., mornings EST, evenings only, etc."
      testidPrefix="funnel-kcis-clinical"
    />
  );
}
